import React, {useState} from "react";
import useInterval from "../../../Utils/UseInterval";
import moment from "moment";
import Leaflet from "leaflet";
import ReactDOMServer from "react-dom/server";
import {Marker, Popup} from "react-leaflet";
import MessengerMarker from "./MessengerMarker/MessengerMarker";
import OrderMarker from "./OrderMarker/OrderMarker";


function renderMarkerPopover() {
    return (props) => {
        const [passedTime, setPassedTime] = useState(0);

        useInterval(() => {
            setPassedTime(moment(props.order.orderTime).fromNow());
        }, 5000);

        return (
            <div>
                <div>
                    מספר הזמנה: {props.order.label}
                </div>
                <div>
                    {props.order.address}
                </div>
                <div>
                    {passedTime || moment(props.order.orderTime).fromNow()}
                </div>
                {
                    props.order.placeOfDeparture ?
                        <div>
                            {props.order.placeOfDeparture}
                        </div>
                        :
                        null
                }
            </div>
        );
    }
}

function renderMessengerMarkerPopover() {
    return (props) => {
        if (!props.assignedDelivery) return false;

        const deliveryTime = moment(props.assignedDelivery.timestamp);

        return (
            <div>
                <div>
                    {props.messenger.name}
                </div>
                <div>
                    {`שובץ ${deliveryTime.fromNow()}`}
                </div>
            </div>
        );
    }
}

function getPinIcon(iconColors, order) {
    if (order.status === "ACCEPTED")
        return iconColors.getPinIconByGroupId(undefined);

    return iconColors.getPinIconByGroupId(order.groupId);
}

export function renderOrderMarker(iconColors, order, onMarkerClick, onMarkerMouseOver, onMarkerMouseOut, innerColor, proposedDeliveryGroups, assignedDeliveryGroups, evaluatingProposedDeliveryGroups, readySla, placesOfDeparture) {
    const MarkerPopoverContent = renderMarkerPopover();
    const pinIcon = getPinIcon(iconColors, order);
    const divIcon = Leaflet.divIcon({
        html: ReactDOMServer.renderToString(
            <OrderMarker order={order}
                         innerColor={innerColor}
                         proposedDeliveryGroups={proposedDeliveryGroups}
                         assignedDeliveryGroups={assignedDeliveryGroups}
                         evaluatingProposedDeliveryGroups={evaluatingProposedDeliveryGroups}
                         pinIcon={pinIcon}
                         readySla={readySla}
                         placesOfDeparture={placesOfDeparture}
            />
        ),
        iconAnchor: new Leaflet.Point(15, 47),
        popupAnchor: new Leaflet.Point(0, -50),
        iconSize: null
    });

    return (
        <Marker key={`marker-order-${order.id}`}
                position={order.location}
                icon={divIcon}
                onMouseOver={(e) => {
                    e.target.openPopup();
                    onMarkerMouseOver();
                }}
                onClick={(e) => {
                    e.target.openPopup();
                    onMarkerClick(e)
                }}
                onMouseOut={(e) => {
                    e.target.closePopup();
                    onMarkerMouseOut();
                }}>
            <Popup>
                <MarkerPopoverContent order={order}/>
            </Popup>
        </Marker>
    );
}

export function renderMessengerMarker(messenger, messengerIcon, users, assignedDeliveryGroups) {
    const MessengerMarkerPopover = renderMessengerMarkerPopover();
    const divIcon = Leaflet.divIcon({
        html: ReactDOMServer.renderToString(<MessengerMarker bearing={messenger.location.bearing}
                                                             messengerIcon={messengerIcon}/>),
        iconAnchor: new Leaflet.Point(10, 15),
        popupAnchor: new Leaflet.Point(0, -15),
        iconSize: null
    });

    const messenger_user = users.find(user => user.id === messenger.uid);
    const assignedDelivery = (assignedDeliveryGroups || []).find(delivery => delivery.messenger_id === messenger.uid);

    return (
        <Marker key={`marker-messenger-${messenger.uid}`}
                position={messenger.location}
                icon={divIcon}
                onMouseOver={(e) => {
                    e.target.openPopup();
                }}
                onMouseOut={(e) => {
                    e.target.closePopup();
                }}>
            <Popup>
                <MessengerMarkerPopover messenger={messenger_user} assignedDelivery={assignedDelivery}/>
            </Popup>
        </Marker>
    );
}